import { Injectable } from "@angular/core";
import { JwtToken } from "../models/jwt-token";

const FOUR = 4, TWO = 2, THREE = 3;

@Injectable({
    providedIn: 'root'
})
export class JwtHelperService {

    urlBase64Decode(str: string): string | undefined {
        try {
            let output = str.replace("-", "+").replace("_", "/");
            switch (output.length % FOUR) {
                case 0: { break; }
                case TWO: { output += "=="; break; }
                case THREE: { output += "="; break; }
                default: {
                    throw new Error("Illegal base64url string!");
                }
            }

            return atob(output);
        } catch (err) {
            console.error(err);
            return undefined;
        }
    }

    decodeToken(token: string): JwtToken | undefined {
        try {
            let parts = token.split(".");

            if (parts.length !== THREE) {
                throw new Error("JWT must have 3 parts");
            }

            let decoded = this.urlBase64Decode(parts[1]);
            if (!decoded) {
                throw new Error("Cannot decode the token");
            }

            return JSON.parse(decoded) as JwtToken;
        } catch (err) {
            console.error(err);
            return undefined;
        }
    }

    getTokenExpirationDate(token: string): Date | undefined {
        let decoded: JwtToken | undefined;
        decoded = this.decodeToken(token);

        if (!decoded?.exp) {
            return undefined;
        }

        var d = new Date(0);
        d.setUTCSeconds(decoded.exp);

        return d;
    }

    isTokenExpired(token: string): boolean {
        if (!token) {
            return true;
        }

        let d = this.getTokenExpirationDate(token);

        if (!d) {
            return false;
        }

        return !(d.valueOf() > new Date().valueOf());
    }
}
